import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UpdateUserMembershipTypeDto, UserMembershipTypeDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIP_TYPES_QUERY_KEY } from './useGetUserMembershipTypes';

export const useUpdateUserMembershipType = (membershipTypeId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateUserMembershipType', membershipTypeId],
        mutationFn: async (body: UpdateUserMembershipTypeDto) => {
            const response = await apiClient.fetchApi<UserMembershipTypeDto, UpdateUserMembershipTypeDto>({ method: 'PUT', endpoint: `user-membership-types/${membershipTypeId}`, body });
            return response
        },
        onSuccess: (data: UserMembershipTypeDto, variables: UpdateUserMembershipTypeDto) => {
            queryClient.setQueryData<UserMembershipTypeDto[]>(GET_USER_MEMBERSHIP_TYPES_QUERY_KEY(data.organizationId), (previousData) => {
                if (!previousData) return [data];
                const index = previousData.findIndex((item) => item.id === membershipTypeId);
                if (index !== -1) {
                    const updatedData = [...previousData];
                    updatedData[index] = data;
                    return updatedData;
                }
                return [...previousData, data];
            });
        }
    });
};